// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { Employee, Student, StudentMedicalEvent, User } from "../../../Utilities";
import { MediaAttachmentFormValues } from "../MediaAttachment";

export type Base = {
	checkInTime: StudentMedicalEvent["checkInTime"] | null;
	checkOutTime: StudentMedicalEvent["checkOutTime"] | null;
	description: StudentMedicalEvent["description"];
	treatment: StudentMedicalEvent["treatment"];
	outcome: StudentMedicalEvent["outcome"];
	notes: StudentMedicalEvent["notes"];
	attendingEmployeeIDs: Employee["id"][];
	studentID: Student["id"] | null;
};

export type Create = Base & {
	mediaAttachments: MediaAttachmentFormValues.CreateInStudentMedicalEvent[];
};

export type CreateRequiredKey = Extract<keyof Create, "description" | "treatment" | "outcome" | "studentID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	checkInTime: null,
	checkOutTime: null,
	description: "",
	treatment: "",
	outcome: "",
	notes: "",
	attendingEmployeeIDs: [],
	mediaAttachments: [],
	studentID: null,
};

export type Detail = Base & {
	authorID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInStudent = Omit<Create, "studentID">;

export type CreateInStudentRequiredKey = Exclude<CreateRequiredKey, "studentID">;

export type CreateInStudentSubset<K extends keyof CreateInStudent = keyof CreateInStudent> = Pick<
	CreateInStudent,
	CreateInStudentRequiredKey | K
>;

export const blankItemInStudent: CreateInStudent = omitKeys(initialCreate, ["studentID"]);
